<template>
  <main>
    <section>
      <transition name="fade-transform" mode="out-in">
        <router-view />
      </transition>
    </section>
  </main>
</template>

<script>
export default {
  name: "AppMain",
};
</script>

<style lang="scss" scoped></style>
